import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e35d52ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title text-center" }
const _hoisted_2 = { class: "tip" }
const _hoisted_3 = { class: "text-center lang-select p-t-5" }
const _hoisted_4 = { class: "form" }
const _hoisted_5 = { class: "tooltip-link" }
const _hoisted_6 = {
  href: "https://bytedance.larkoffice.com/wiki/TxE9wAbpCiOUx8k4w0Oc084Znid",
  target: "_blank"
}
const _hoisted_7 = { class: "text-white" }
const _hoisted_8 = { class: "g-fw7 text-cyan" }
const _hoisted_9 = { class: "text-white" }
const _hoisted_10 = { class: "g-fw7 text-cyan" }
const _hoisted_11 = { class: "text-center w-100" }
const _hoisted_12 = { class: "code" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "text" }

import { ref, reactive, onMounted, computed, watch,nextTick, onUnmounted } from "vue";
import {
  postStudentSubjectInfo,
  postStudentSubjectSave,
  postStudentSubjectList,
  SubjectItemType,
  positionItemType,
  postBasePositionList,
} from "@/api/request/user";
import { getDictList, dictItemType } from "@/api/request";
import { FormRules, FormInstance, ElMessage, ElMessageBox } from "element-plus";
import { postBaseSiteInfo } from "@/api/request/user";
import store from "@/store";
import router from "@/router";
import { useI18n } from "vue-i18n";
import { QuestionFilled  } from '@element-plus/icons-vue'
import { useRoute } from 'vue-router';

import LockDialog from "@/components/LockDialog.vue";
import serviceIcon from "@/assets/operate/service.png";
import { getHomeMarketData } from "@/api/request/login";

export default /*#__PURE__*/_defineComponent({
  __name: 'MobileUserSelect',
  setup(__props) {

const { t } = useI18n(); 
//志成添加
const route = useRoute();
//end----

const labelStr = computed(()=>{

  var s = '';
  switch(queryForm.value.inputType){
    case 5:
      s = t('主体名称-'+(lang.value === 'zh-CN' ? 'cn' : 'en'));
      break;
    case 7:
      s = 'Shop ID';
      break;
    case 8:
      s = 'Shop Code'
      break;
    case 9:
      s = 'Adv ID'
      break;
    case  10:
      s = t('集团名称-'+(lang.value === 'zh-CN' ? 'cn' : 'en'));
      break; 
  }

  return s;

})



const dutyList = ref([] as positionItemType[]);
const dutyListEn = ref([] as positionItemType[]);

const dutyStr = ref("");
const agent_improve_info_tips = ref("");
const subjectStr = ref("");
const navData = ref([] as any[]);
const navDataEn = ref([] as any[]);

onMounted(() => {
  postBaseSiteInfo({ type: "agent_improve_info_tips" }).then((res) => {
    if (res.data["agent_improve_info_tips"])
      agent_improve_info_tips.value = JSON.parse(
        res.data["agent_improve_info_tips"]
      ).data.replace(/\n/g, "<br/>");
  });
  // getDictList({ type: "agent_job_list" }).then((res) => {
  //   dutyList.value = res.data;
  //   dutyList.value.push({
  //     label: t("其他"),
  //     value: "-1",
  //     businessId: "-1",
  //   });
  // });
  postBasePositionList({},{
    headers: {
      "locale-language":"zh-CN"
    } 
  }).then((res) => {
    dutyList.value = res.data;
  });

   postBasePositionList({},{
    headers: {
      "locale-language":"en-US"
    }
  }).then((res) => {
      dutyListEn.value = res.data;
  });

  getDictList({ type: "subject_catagory" }).then((res) => {
    catagoryList.value = res.data;
  });

  getHomeMarketData({
    "locale-language":"zh-CN"
  }).then((res) => {
    navData.value = res.data || [];
  })


  getHomeMarketData({
    "locale-language":"en-US"
  }).then((res) => {
      navDataEn.value = res.data || [];
  })

});
const subjectList = ref([] as SubjectItemType[]);
const subjectUseType2List = ref([] as SubjectItemType[]);  //增加一个单独的列表，专门给userType=2使用，避免其他类型过多时，查询不方便
const subjectListSEA = ref([] as SubjectItemType[]);
const catagoryList = ref([] as dictItemType[]);
// const userInfo = computed(() => {
//   return store.state.user.userInfo;
// });
// const isChangeLevel = ref(false);
// const $emits = defineEmits(["reload"]);
// const num = ref(5);
// onMounted(() => {
//   // 品牌方 有主体 展示无权限
//   // 品牌方 无主体 展示账号升级
//   // 代理商 无主体 展示账号升级
//   postStudentSubjectInfo().then((res) => {
//     if (!res.data) {
//       remoteMethod("");
//     } else {
//       queryForm.value.duty = res.data.duty;
//       queryForm.value.subjectId = res.data.subjectName;
//       queryForm.value.studentName = res.data.studentName;
//       queryForm.value.email = res.data.email;
//       num.value = res.data.num as number;
//       isEdit.value = false;
//     }
//   });
// });

const num = computed(()=>{
  return store.state.user.userInfo.num
})

const dutyArr = ref([] as string[]);
const isUseType = ref(false);
watch(
  () => store.state.user.infoPerfectDialog,
  () => {
    if (store.state.user.infoPerfectDialog) {
      // num.value = store.state.user.userInfo.num;
      postStudentSubjectInfo().then((res) => {
        if (!res.data || res.data.status === 2) {
          remoteMethod("");
          remoteMethodSEA("");
          dutyArr.value = [];
          queryForm.value.duty = "";
          queryForm.value.subjectName = "";
          queryForm.value.subjectId = "";
          queryForm.value.studentName = "";
          queryForm.value.email = "";
          if (
            (store.state.user.userInfo.useSubject ||
              store.state.user.userInfo.subjectNum !== 0) &&
            num.value !== 0
          ) {
            queryForm.value.userType = res.data ? Number(res.data.userType) : 1;
            isUseType.value = true;
          } else {
            // queryForm.value.subjectName = store.state.user.userInfo.useSubject;
            queryForm.value.userType = 2;
            isUseType.value = false;
          }
          isEdit.value = true;
        } else {
          if (res.data.duty && res.data.dutyIds) {
            queryForm.value.duty = res.data.duty;
            queryForm.value.dutyIds = res.data.dutyIds;
            const dutyIds = res.data.dutyIds.split(",");
            dutyArr.value = [...dutyIds];
          }
          queryForm.value.subjectId = res.data.subjectName;
          queryForm.value.studentName = res.data.studentName;
          queryForm.value.email = res.data.email;
          queryForm.value.catagory = res.data.catagory;
          isEdit.value = false;
          if (
            res.data.userType === "4" &&
            (res.data.userTypeExp === "1" || res.data.userTypeExp === "2")
          ) {
            queryForm.value.userType = Number(
              res.data.userType + "." + res.data.userTypeExp
            );
          } else {
            queryForm.value.userType = Number(res.data.userType);
          }
        }
      });
      if (num.value === 0) {
        queryForm.value.userType = 2;
        isEdit.value = true;
      }
    }
  }
);
const loading = ref(false);
const remoteMethod = (query: string) => {
  loading.value = true;
  postStudentSubjectList({ label: query, agentType: 1 })
    .then((res) => {
      subjectList.value = res.data;
      subjectList.value.push({
        label: t("其他"),
        businessId: "-1",
      });
    })
    .finally(() => {
      loading.value = false;
    });
};
const loading1 = ref(false);
const remoteMethodUseType2 = (query: string) => {
  
  //query大于等于2个字符才请求接口，减少不必要的请求
  if(query.length < 2) {
    subjectUseType2List.value = [];
    return;
  }

  loading1.value = true;
  postStudentSubjectList({ label: query, agentType: queryForm.value.inputType as number })
    .then((res) => {
      //取三条数据给userType=2使用
      if(res.data.length > 3) {
        res.data = res.data.slice(0, 3);
      }
      subjectUseType2List.value = res.data;
      
    })
    .finally(() => {
      loading1.value = false;
    });
};
 



const remoteMethodSEA = (query: string) => {
  loading.value = true;
  postStudentSubjectList({ label: query, agentType: 4 })
    .then((res) => {
      subjectListSEA.value = res.data;
      subjectListSEA.value.push({
        label: t("其他SEA"),
        businessId: "-1",
      });
    })
    .finally(() => {
      loading.value = false;
    });
};
/** 是否允许编辑 */
const isEdit = ref(true);
const queryForm = ref({ userType: 2,inputType:9 } as {
  subjectId?: string;
  catagory?: string;
  studentName?: string;
  email: string;
  duty?: string;
  dutyIds: string;
  userType?: number;
  subjectName?: string;
  inputType: number;
  advId:number | string;
  marketId?:string;
});

watch(
  () => queryForm.value.userType,
  () => {
    dutyList.value = [];
    if (queryForm.value.userType === 4.1 || queryForm.value.userType === 4.2) {
      postBasePositionList(
        {},
        {
          headers: {
            "locale-language": "en-US",
          },
        }
      ).then((res) => {
        dutyList.value = res.data;
      });
    } else {
      postBasePositionList().then((res) => {
        dutyList.value = res.data;
      });
    }
  }
);
function userTypeChange() {
  queryForm.value.duty = "";
  queryForm.value.dutyIds = "";
  queryForm.value.subjectName = "";
  queryForm.value.subjectId = "";
  queryForm.value.catagory = "";
  queryForm.value.studentName = "";
  queryForm.value.email = "";
  queryForm.value.marketId = "";

 
 
}

const  inputTypeChange = () => {
  queryForm.value.subjectName = "";
  queryForm.value.subjectId = "";
  //  if (queryForm.value.userType === 2) {
  //   getSubjectUseType2List();
  // } else {
  //   subjectUseType2List.value = []; 
  //  }
};

const saveloading = ref(false);
async function saveForm() {
  if (!queryFormRef.value) return;
  // if (
  //   queryForm.value.userType === 1 &&
  //   queryForm.value.duty === t("其他") &&
  //   !dutyStr.value
  // )
  //   return ElMessage.error(t("请填写岗位信息"));
  if (
    queryForm.value.userType === 1 &&
    queryForm.value.subjectId === t("其他") &&
    !subjectStr.value
  )
    return ElMessage.error(t("请填写代理商简称"));
  const duty = [] as string[];
  const dutyIds = [] as string[];
  dutyArr.value.forEach((item) => {
    let _obj = dutyList.value.find((d) => d.businessId === item);
    duty.push(_obj?.positionFmt || "");
    dutyIds.push(item);
  });
  queryForm.value.duty = duty.toString();
  queryForm.value.dutyIds = dutyIds.toString();
  await queryFormRef.value.validate((valid) => {
    if (valid) {
      saveloading.value = true;
      let data = { userTypeExp: "" } as {
        subjectId?: string;
        catagory?: string;
        studentName?: string;
        email?: string;
        duty?: string;
        userType?: number;
        subjectName?: string;
        userTypeExp?: string;
        advId?: number | string; 
        shopId?:string
        shopCode ?: string;
        groupName?: string;
        marketId?:string
      };
      if (queryForm.value.userType === 1) {  //代理商

        if(queryForm.value.marketId ==='2013887169182171136'){  //中国
            data = { ...queryForm.value };
            data.subjectName = data.subjectId;
            if (
              queryForm.value.subjectId === t("其他") ||
              queryForm.value.subjectId === t("其他SEA")
            ) {
              data.subjectName = subjectStr.value;
            }
            delete data.subjectId;
            if (queryForm.value.duty === t("其他")) {
              data.duty = dutyStr.value;
            }
        }

        if(queryForm.value.marketId === '2013896102084345856' || queryForm.value.marketId === '2013897757941432320'){  //东南亚或日本
            data = { ...queryForm.value };
            data.subjectName = data.subjectId;
            delete data.subjectId;
            if (queryForm.value.duty === t("其他")) {
              data.duty = dutyStr.value;
            }
            let _userType = queryForm.value.userType + "";
            // data.userType = 4;
            data.userType = queryForm.value.userType;
            data.userTypeExp = _userType.split(".")[1];
        }
        
      }else if(queryForm.value.userType === 2 ){  //商家
        data = {
          userType: queryForm.value.userType,
          marketId: queryForm.value.marketId,
          //subjectName: queryForm.value.subjectName,
        };

        switch(queryForm.value.inputType) {
          case 5:{
            //判断所选值类型 20260325提交 shopId/advId合并选择根据类型 判断传值字段
            const typeTmp = subjectUseType2List.value?.find(item=>item.label===queryForm.value.subjectName);
            data.subjectName = typeTmp?.businessId;
            break;
          }
          case 7:{
             //判断所选值类型 20260324提交 shopId/advId合并选择根据类型 判断传值字段
            // const typeTmp = subjectUseType2List.value?.find(item=>item.label===queryForm.value.subjectName);
            // data.shopId = (typeTmp && typeTmp.agentType===7) ? queryForm.value.subjectName:'';
            data.shopId = queryForm.value.subjectName;

            // data.advId = (typeTmp && typeTmp.agentType===9) ? queryForm.value.subjectName:'';
            break;
          }
          case 8:
            data.shopCode = queryForm.value.subjectName;
            break;
          case 9:
            data.advId = queryForm.value.subjectName;
            break; 
          case 10:{
            const typeTmp1 = subjectUseType2List.value?.find(item=>item.label===queryForm.value.subjectName); 
            data.groupName = typeTmp1?.businessId;
            break; 
          }
            
        }
 
      } else {
        data = {
          userType: queryForm.value.userType,
          subjectName: queryForm.value.subjectName,
          marketId: queryForm.value.marketId,
        };
      } 


      var p = {...data};

      if(p.userType === 1){
        if(p.marketId === '2013896102084345856'){
          p.userType = 4
        }
        if(p.marketId === '2013897757941432320'){
          p.userType = 11
        }
      }

      postStudentSubjectSave(p)
        .then((res) => {
          if (res.data.status === 1) {
             if(res.data.token !=''){
              localStorage.setItem(process.env.VUE_APP_TOKEN_KEY, res.data.token);
              window.location.reload();
              return;
            }
            store.dispatch("GetInfo").finally(() => {
              store.commit("SET_INFO_PERFECT_DIALOG", false);
            });
          } else {
            store.commit("SET_INFO_PERFECT_DIALOG", false);
          }
        })
        .finally(() => {
          saveloading.value = false;
        });
    }
  });
}
const queryFormRef = ref<FormInstance>();
const validatePass = (rule: any, value: any, callback: any) => {
  


  // const emailRegex = /^[a-zA-Z0-9_+&*-]+(?:\.[a-zA-Z0-9_+&*-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,7}$/;
  // if (queryForm.value.email && !emailRegex.test(queryForm.value.email)) {
  //   return callback(
  //     new Error(
  //       t(
  //         "请输入正确的公司邮箱" +
  //           (queryForm.value.userType === 4.1 ||
  //           queryForm.value.userType === 4.2
  //             ? "SEA"
  //             : "")
  //       )
  //     )
  //   );
  // }

  if(queryForm.value.email.indexOf('@')<0){
    return callback(
      new Error(
        t(
          "请输入正确的公司邮箱-" +
            (lang.value === 'zh-CN'
              ? "cn"
              : "en")
        )
      )
    );
  }



  callback();
};
const rules = computed<FormRules>(() => {
  return {
    marketId: [
      { required: true, message: t("请选择市场-"+(lang.value === 'zh-CN' ? 'cn' : 'en')), trigger: "blur" },
    ],
    userType: [
      { required: true, message: t("请选择学员类型-"+(lang.value === 'zh-CN' ? 'cn' : 'en')), trigger: "blur" },
    ],
        inputType: [
        { required: true, message: t("请选择填写方式-"+(lang.value === 'zh-CN' ? 'cn' : 'en')), trigger: "blur" },
      ],
    advId: [
      {
        required:true,
        message: 'Please enter the Shop ID/adv ID',
        trigger: "blur",
      },
    ],
    subjectId: [
      {
        required: true,
        message: t(
          "请输入代理商简称-" +
            (lang.value === 'zh-CN'
              ? "cn"
              : "en")
        ),
        trigger: "blur",
      },
    ],
    catagory: [
      {
        required: true,
        message: "Please select Catagory",
        trigger: "blur",
      },
    ],
    duty: [
      {
        required: true,
        message: t(
          "请输入岗位信息-" +
            (lang.value === 'zh-CN'
              ? "cn"
              : "en")
        ),
        trigger: "blur",
      },
    ],
    studentName: [
      {
        required: true,
        message: t(
          "请输入姓名-" +
            (lang.value === 'zh-CN'
              ? "cn"
              : "en")
        ),
        trigger: "blur",
      },
    ],
    subjectName: [
      { required: true, 
        message: t('请准确填写信息,否则将无法正常进入学习-'+
            (lang.value === 'zh-CN'
              ? "cn"
              : "en")), trigger: "blur" },
    ],
    email: [
      {
        required: true,
        message: t(
          "请输入公司邮箱-" +
            (lang.value === 'zh-CN'
              ? "cn"
              : "en")
        ),
        trigger: "blur",
      },
      { validator: validatePass, trigger: "blur" },
    ],
  };
});
// const changeCurrent = ref("");

// const dialogVisible = ref(false);

function beforeClose() {
  console.log("请勿关闭");
  if (!subjectNum.value) {
    ElMessageBox.confirm(
      t("确认关闭？信息正确完善前，您的部分功能可能受限"),
      t("提示"),
      {
        confirmButtonText: t("确定关闭"),
        cancelButtonText: t("取消"),
        type: "info",
      }
    )
      .then(() => {
        store.commit("SET_INFO_PERFECT_DIALOG", false);
        router.replace("/");
      })
      .catch(() => {
        // 取消
      });
  }
  return false;
}

const handleOpen = () => {
  console.log('Dialog opened');
  alert('Dialog opened');
}; 
 
 

const dialogVisible = computed(() => { 
 
  //志成修改------
  
    if(route.path.indexOf('courseClockIn') > -1){  //手机打卡页不用弹窗
      return false;
    }else{   
      return store.state.user.infoPerfectDialog;
    }   

  //--end
 
});
 
 
const subjectNum = computed(() => {
  return (
    !store.state.user.userInfo.useType && !store.state.user.userInfo.subjectNum
  );
});
 
// function save() {
//   postBaseEditStudentType({ type: changeCurrent.value })
//     .then(() => {
//       store.commit("SET_USERINFO_TYPE", changeCurrent.value);
//       dialogVisible.value = false;
//     })
//     .catch((err) => {
//       ElMessage.error(err.msg || "设置不成功，请稍后再试");
//     });
// }

const lockDialog = ref();
const openedFun = () => {
  nextTick(() => {
    if (lockDialog.value) {
      lockDialog.value.lock();
    }
   }); 
};

const handleQuestionClick = () => {
   window.open('https://bytedance.larkoffice.com/wiki/TxE9wAbpCiOUx8k4w0Oc084Znid', '_blank');
};

const lang = ref('zh-CN');
const marketChange = () => {
  queryForm.value.subjectId = '';
  queryForm.value.subjectName = '';
  queryForm.value.duty = '';
  queryForm.value.dutyIds = '';
  queryForm.value.studentName = '';
  queryForm.value.email = '';
  dutyArr.value = [];
};


return (_ctx: any,_cache: any) => {
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(LockDialog, {
    ref_key: "lockDialog",
    ref: lockDialog
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_isRef(dialogVisible) ? (dialogVisible).value = $event : null)),
        onOpened: openedFun,
        width: "100%",
        "destroy-on-close": "",
        "show-close": !_unref(subjectNum),
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": beforeClose
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t(
          '信息完善-' +
            (lang.value === 'zh-CN' ? 'cn'
              : 'en')
        )), 1)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('请您完善并准确填写所有信息，确保信息真实有效。信息填写无误后，方可正常进入平台学习并获得后续平台活动激励。您的所有信息将严格保密，不会对外泄露。感谢您的配合！-'+(lang.value === 'zh-CN' ? 'cn' : 'en'))), 1),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_radio_group, {
              modelValue: lang.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((lang).value = $event)),
              size: "small"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_button, {
                  label: "中文",
                  value: "zh-CN"
                }),
                _createVNode(_component_el_radio_button, {
                  label: "EN",
                  value: "en-US"
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_form, {
              ref_key: "queryFormRef",
              ref: queryFormRef,
              rules: _unref(rules),
              model: queryForm.value,
              size: "default",
              disabled: !isEdit.value,
              "label-width": "120px",
              onSubmit: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["prevent"])),
              "label-position": 'left'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: 
              _ctx.$t(
                '学员类型-' +
                  (lang.value === 'zh-CN'
                    ? 'cn'
                    : 'en')
              )
            ,
                  prop: "userType"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_group, {
                      modelValue: queryForm.value.userType,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.value.userType) = $event)),
                      class: "ml-4 user-type-group",
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (userTypeChange()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio, {
                          value: 2,
                          disabled: _unref(num) === 0 || isUseType.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t(
                  "商家-" +
                    (lang.value === 'zh-CN'
                      ? "cn"
                      : "en")
                )), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        _createVNode(_component_el_radio, { value: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t(
                  "代理商-" +
                    (lang.value === 'zh-CN'
                      ? "cn"
                      : "en")
                )), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                (queryForm.value.userType === 1)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: _ctx.$t('市场-'+
                  (lang.value === 'zh-CN'
                    ? 'cn'
                    : 'en')),
                      prop: "marketId"
                    }, {
                      default: _withCtx(() => [
                        (lang.value === 'en-US')
                          ? (_openBlock(), _createBlock(_component_el_select, {
                              key: 0,
                              modelValue: queryForm.value.marketId,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.value.marketId) = $event)),
                              placeholder: lang.value === 'en-US' ? 'Please select' : '请选择',
                              onChange: marketChange
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navDataEn.value, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.businessId,
                                    label: item.name,
                                    value: item.businessId
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "placeholder"]))
                          : (_openBlock(), _createBlock(_component_el_select, {
                              key: 1,
                              modelValue: queryForm.value.marketId,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.value.marketId) = $event)),
                              placeholder: lang.value === 'en-US' ? 'Please select' : '请选择',
                              onChange: marketChange
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navData.value, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.businessId,
                                    label: item.name,
                                    value: item.businessId
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "placeholder"]))
                      ]),
                      _: 1
                    }, 8, ["label"]))
                  : _createCommentVNode("", true),
                (queryForm.value.userType === 2)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      label: _ctx.$t('填写方式'),
                      prop: "inputType"
                    }, {
                      label: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('填写方式-'+(lang.value === 'zh-CN' ? 'cn' : 'en'))) + " ", 1),
                        _createVNode(_component_el_tooltip, { placement: "top" }, {
                          content: _withCtx(() => [
                            _createElementVNode("div", null, _toDisplayString(_ctx.$t('请选择任一填写-'+(lang.value === 'zh-CN' ? 'cn' : 'en'))), 1),
                            _createElementVNode("div", _hoisted_5, [
                              _createElementVNode("a", _hoisted_6, "UID/ Shop ID/ ShopCode " + _toDisplayString(_ctx.$t('查找方式-'+(lang.value === 'zh-CN' ? 'cn' : 'en'))), 1)
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_unref(QuestionFilled), { class: "QuestionFilled" })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_group, {
                          class: "user-type-group",
                          modelValue: queryForm.value.inputType,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.value.inputType) = $event)),
                          onChange: inputTypeChange
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio, { value: 9 }, {
                              default: _withCtx(() => [
                                _createTextVNode("Adv ID")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_radio, { value: 5 }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('主体名称填写-'+(lang.value === 'zh-CN' ? 'cn' : 'en'))), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_radio, { value: 7 }, {
                              default: _withCtx(() => [
                                _createTextVNode("Shop ID")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_radio, { value: 8 }, {
                              default: _withCtx(() => [
                                _createTextVNode("Shop Code")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_radio, { value: 10 }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('集团名称-'+(lang.value === 'zh-CN' ? 'cn' : 'en'))), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"]))
                  : _createCommentVNode("", true),
                (queryForm.value.userType === 1 && queryForm.value.marketId === '2013887169182171136')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('代理商简称-'+(lang.value === 'zh-CN' ? 'cn' : 'en')),
                        prop: "subjectId"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: queryForm.value.subjectId,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((queryForm.value.subjectId) = $event)),
                            filterable: "",
                            remote: "",
                            loading: loading.value,
                            "remote-method": remoteMethod,
                            placeholder: _ctx.$t('请选择代理商，可通过关键字查询，如没有检索结果请选择其他选项-'+(lang.value === 'zh-CN' ? 'cn' : 'en'))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subjectList.value, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  class: "option-width",
                                  key: item.businessId,
                                  label: item.label,
                                  value: item.label
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "loading", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      (queryForm.value.subjectId === _ctx.$t('其他'))
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: " "
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: subjectStr.value,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((subjectStr).value = $event)),
                                modelModifiers: { trim: true },
                                maxlength: "200",
                                "show-word-limit": "",
                                placeholder: _ctx.$t('请输入代理商简称-'+(lang.value === 'zh-CN' ? 'cn' : 'en'))
                              }, null, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('学员名称-'+(lang.value === 'zh-CN' ? 'cn' : 'en')),
                        prop: "studentName"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: queryForm.value.studentName,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((queryForm.value.studentName) = $event)),
                            modelModifiers: { trim: true },
                            maxlength: "50",
                            "show-word-limit": "",
                            placeholder: _ctx.$t('请输入姓名（请填写你在公司的真实姓名）-'+(lang.value === 'zh-CN' ? 'cn' : 'en'))
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('岗位-'+(lang.value === 'zh-CN' ? 'cn' : 'en')),
                        prop: "duty"
                      }, {
                        default: _withCtx(() => [
                          (lang.value === 'en-US')
                            ? (_openBlock(), _createBlock(_component_el_select, {
                                key: 0,
                                modelValue: dutyArr.value,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dutyArr).value = $event)),
                                multiple: "",
                                "collapse-tags-tooltip": "",
                                placeholder: _ctx.$t('请选择岗位信息-'+(lang.value === 'zh-CN' ? 'cn' : 'en'))
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dutyListEn.value, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.businessId,
                                      label: item.positionFmt,
                                      value: item.businessId
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"]))
                            : (_openBlock(), _createBlock(_component_el_select, {
                                key: 1,
                                modelValue: dutyArr.value,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((dutyArr).value = $event)),
                                multiple: "",
                                "collapse-tags-tooltip": "",
                                placeholder: _ctx.$t('请选择岗位信息-'+(lang.value === 'zh-CN' ? 'cn' : 'en'))
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dutyList.value, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.businessId,
                                      label: item.positionFmt,
                                      value: item.businessId
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"]))
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('公司邮箱-'+(lang.value === 'zh-CN' ? 'cn' : 'en')),
                        prop: "email"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: queryForm.value.email,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((queryForm.value.email) = $event)),
                            modelModifiers: { trim: true },
                            maxlength: "100",
                            "show-word-limit": "",
                            placeholder: _ctx.$t('请输入公司邮箱-'+(lang.value === 'zh-CN' ? 'cn' : 'en'))
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_form_item, { label: "" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_7, [
                            _createTextVNode(_toDisplayString(_ctx.$t("提示: 提交成功后,请耐心等待管理员审核.-"+(lang.value === 'zh-CN' ? 'cn' : 'en'))) + " ", 1),
                            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("剩余审核次数:N次-"+(lang.value === 'zh-CN' ? 'cn' : 'en'), { text: _unref(num) })), 1)
                          ])
                        ]),
                        _: 1
                      })
                    ], 64))
                  : _createCommentVNode("", true),
                (queryForm.value.userType === 2)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createVNode(_component_el_form_item, {
                        label: _unref(labelStr),
                        prop: "subjectName"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: queryForm.value.subjectName,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((queryForm.value.subjectName) = $event)),
                            filterable: "",
                            remote: "",
                            loading: loading1.value,
                            "remote-method": remoteMethodUseType2,
                            placeholder: lang.value === 'en-US' ? 'Please enter' : '请输入'
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subjectUseType2List.value, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  class: "option-width",
                                  key: item.businessId,
                                  label: item.label,
                                  value: item.label
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "loading", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_form_item, { label: "" })
                    ], 64))
                  : _createCommentVNode("", true),
                (queryForm.value.userType === 1 && (queryForm.value.marketId === '2013896102084345856' || queryForm.value.marketId === '2013897757941432320'))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('代理商简称-'+(lang.value === 'zh-CN' ? 'cn' : 'en')),
                        prop: "subjectId"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: queryForm.value.subjectId,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((queryForm.value.subjectId) = $event)),
                            modelModifiers: { trim: true },
                            maxlength: "200",
                            "show-word-limit": "",
                            placeholder: _ctx.$t('请输入代理商简称-'+(lang.value === 'zh-CN' ? 'cn' : 'en'))
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('学员名称-'+(lang.value === 'zh-CN' ? 'cn' : 'en')),
                        prop: "studentName"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: queryForm.value.studentName,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((queryForm.value.studentName) = $event)),
                            modelModifiers: { trim: true },
                            maxlength: "50",
                            "show-word-limit": "",
                            placeholder: _ctx.$t('请输入姓名（请填写你在公司的真实姓名）-'+(lang.value === 'zh-CN' ? 'cn' : 'en'))
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('公司邮箱-'+(lang.value === 'zh-CN' ? 'cn' : 'en')),
                        prop: "email"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: queryForm.value.email,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((queryForm.value.email) = $event)),
                            modelModifiers: { trim: true },
                            maxlength: "100",
                            "show-word-limit": "",
                            placeholder: _ctx.$t('请输入公司邮箱-'+(lang.value === 'zh-CN' ? 'cn' : 'en'))
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_form_item, { label: "" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_9, [
                            _createTextVNode(_toDisplayString(_ctx.$t("提示: 提交成功后,请耐心等待管理员审核.-"+(lang.value === 'zh-CN' ? 'cn' : 'en'))) + " ", 1),
                            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("剩余审核次数:N次-"+(lang.value === 'zh-CN' ? 'cn' : 'en'), { text: _unref(num) })), 1)
                          ])
                        ]),
                        _: 1
                      })
                    ], 64))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, {
                  "label-width": "0",
                  class: "m-t-30"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        size: "large",
                        round: "",
                        color: "#fe2c55",
                        class: "btn-min-width",
                        loading: saveloading.value,
                        onClick: saveForm,
                        disabled: _unref(num) ==0 && (queryForm.value.userType === 1 || queryForm.value.userType === 4)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(isEdit.value
                  ? _ctx.$t(
                      "提交-" +
                        (lang.value === 'zh-CN'
                          ? "cn"
                          : "en")
                    )
                  : _ctx.$t(
                      "待审核" +
                        (queryForm.value.userType === 4
                          ? "SEA"
                          : "")
                    )), 1)
                        ]),
                        _: 1
                      }, 8, ["loading", "disabled"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["rules", "model", "disabled"]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("img", { src: _unref(serviceIcon) }, null, 8, _hoisted_13),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('如您在填写过程中遇到问题,请扫码入群反馈-'+(lang.value === 'zh-CN' ? 'cn'
                      : "en"))), 1)
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "show-close"])
    ]),
    _: 1
  }, 512))
}
}

})